import { Button } from 'primereact/button';
import { type ReactNode } from 'react';
import { DialogButtonsConfig } from '../types';
import {
    DialogWithDoubleEscape,
    useDialogClose,
} from './DialogWithDoubleEscape';

interface DefaultDialogProps {
    title?: ReactNode;
    buttons?: DialogButtonsConfig;
    children: ReactNode;
    onClose: () => void;
}

export function DefaultDialog({
    title,
    children,
    onClose,
    buttons,
}: DefaultDialogProps): ReactNode {
    function ButtonsContent(): ReactNode {
        const close = useDialogClose();
        const buttonsTemplate = (
            <Button label={buttons?.submitLabel ?? 'Ok'} onClick={close} />
        );

        return (
            <div className="flex flex-row justify-content-center mt-5">
                <div className="flex flex-row gap-2">
                    {buttons?.content ?? null}
                    {!buttons?.content && buttonsTemplate}
                </div>
            </div>
        );
    }

    function HeaderContent(): ReactNode {
        const close = useDialogClose();
        return (
            <div className="flex flex-row justify-content-between">
                <div className="flex align-items-center">{title}</div>
                <Button label="Close" outlined size="small" onClick={close} />
            </div>
        );
    }

    return (
        <DialogWithDoubleEscape
            onClose={onClose}
            className="dialog-confirm"
            header={<HeaderContent />}
        >
            {children}
            <ButtonsContent />
        </DialogWithDoubleEscape>
    );
}
